import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ChatReplyModel } from '@models/chat-reply.model'
import MainConfig from '../../../../config/main'

@Component({
    selector: 'app-chat-reaction',
    templateUrl: './chat-reaction.component.html',
    styleUrls: ['./chat-reaction.component.css'],
})
export class ChatReactionComponent implements OnInit {
    @Input() isPatient = false
    @Input() replyModel: ChatReplyModel
    @Output() _onReact: EventEmitter<number> = new EventEmitter<number>()

    @Input() reactIndex = 0
    disabled = false
    public enableSetting: boolean

    constructor() {
        this.enableSetting = MainConfig.ENABLE_CHAT_REACTION
    }

    ngOnInit() {
        this.disabled = this.isPatient == this.replyModel.isPatient
    }

    changeReact(reactIndex) {
        console.debug('changeReact')

        this.reactIndex = reactIndex

        if (this.isPatient) {
            this.replyModel.patientReact = this.reactIndex
        } else {
            this.replyModel.clinicReact = this.reactIndex
        }
        this._onReact.emit(this.reactIndex)
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat-reaction/chat-reaction.component.ts